import { useState } from "react";
import faqList from "../faqList";

function FAQ() {
	const [openIndex, setOpenIndex] = useState(0);

	const toggleItem = (index) => {
		setOpenIndex((current) => (current === index ? null : index));
	};

	return (
		<section id="faq" className="faqSection">
			<div className="faqPanel">
				<div className="faqGrid">
					<div className="faqIntro">
						<h2 className="faqHeading">Questions people ask us.</h2>
						<p className="faqIntroText">
							A few things newcomers and longtime members want to know
							before their first gathering.
						</p>
						<a
							href="mailto:info.gcasregina@gmail.com"
							className="btn btnPrimary faqCta"
						>
							Email Us
							<span className="btnIcon" aria-hidden="true">
								<i className="fa-solid fa-envelope"></i>
							</span>
						</a>
					</div>

					<div className="faqList">
						{faqList.map((item, index) => {
							const isOpen = index === openIndex;
							return (
								<div
									key={item.question}
									className={`faqItem ${isOpen ? "active" : ""}`}
								>
									<button
										className="faqQuestion"
										onClick={() => toggleItem(index)}
										aria-expanded={isOpen}
									>
										<span>{item.question}</span>
										<span className="faqToggleIcon" aria-hidden="true">
											<i
												className={`fa-solid ${
													isOpen ? "fa-xmark" : "fa-plus"
												}`}
											></i>
										</span>
									</button>
									<div className="faqAnswerWrap">
										<p className="faqAnswer">{item.answer}</p>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</section>
	);
}

export default FAQ;
